// extracted by mini-css-extract-plugin
export default {"mapArea":"MapLoader_mapArea__H8vem","map":"MapLoader_map__aCt3t","map--fetching":"MapLoader_map--fetching__DbJuf","loadingOverlay":"MapLoader_loadingOverlay__jtB+X"};